import script from "./SignupSourceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SignupSourceCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import ReportDelta from "@/components/reports/ReportDelta.vue";
script.components = Object.assign({}, { ReportDelta }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { ReportDelta }, script.__o.components);}